var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbitrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1477_5605)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.75 25C48.75 11.8832 38.1168 1.25 25 1.25C11.8832 1.25 1.25 11.8832 1.25 25C1.25 38.1168 11.8832 48.75 25 48.75C38.1168 48.75 48.75 38.1168 48.75 25Z",
    fill: "#2D374B",
    stroke: "#96BEDC",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1477_5605",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 48,
    height: 48
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.8095 25C48.8095 11.8504 38.1496 1.19048 25 1.19048C11.8503 1.19048 1.19043 11.8504 1.19043 25C1.19043 38.1496 11.8503 48.8095 25 48.8095C38.1496 48.8095 48.8095 38.1496 48.8095 25Z",
    fill: "#C4C4C4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1477_5605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.1536 33.2216L36.7632 51.4786L43.9162 47.3334L29.8805 25.2007L25.1536 33.2216ZM48.5007 39.4166L48.4953 36.0954L35.4482 15.7257L31.3255 22.7209L43.988 43.1321L47.8666 40.8846C48.0545 40.7324 48.2081 40.5422 48.3175 40.3266C48.4269 40.1109 48.4896 39.8746 48.5014 39.633L48.5007 39.4166Z",
    fill: "#28A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M48.1248 25C48.1248 12.2284 37.7713 1.875 24.9998 1.875C12.2282 1.875 1.87476 12.2284 1.87476 25C1.87476 37.7716 12.2282 48.125 24.9998 48.125C37.7713 48.125 48.1248 37.7716 48.1248 25Z",
    fill: "url(#paint0_linear_1477_5605)",
    fillOpacity: 0.3,
    stroke: "#96BEDC",
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.648779 50.3941L-4.83336 47.238L-5.25122 45.75L13.8322 16.1061C15.1354 13.9788 17.9745 13.2936 20.6102 13.3309L23.7036 13.4125L0.648779 50.3941ZM34.224 13.4125L26.0716 13.4421L3.99985 49.9166L10.4468 53.6288L12.2 50.6552L34.224 13.4125Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1477_5605",
    x1: -0.000243755,
    y1: -7.32171e-7,
    x2: 24.9998,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1477_5605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.fe395df21a4ad83a21e7ce1dde219cc9.svg";
export { ForwardRef as ReactComponent };